export default {
  FallbackForm: () =>
    import(/* webpackChunkName: "FallbackForm" */ '@/js/components/HubSpot/Forms/FallbackForm.vue'),
  ExampleForm: () =>
    import(/* webpackChunkName: "ExampleForm" */ '@/js/components/HubSpot/Forms/ExampleForm.vue'),
  WarrantyGuaranteeGuaranteeForm: () =>
    import(
      /* webpackChunkName: "WarrantyGuaranteeGuaranteeForm" */ '@/js/components/HubSpot/Forms/WarrantyGuaranteeGuaranteeForm.vue'
    ),
  WarrantyGuaranteeBatteryChargerForm: () =>
    import(
      /* webpackChunkName: "WarrantyGuaranteeBatteryChargerForm" */ '@/js/components/HubSpot/Forms/WarrantyGuaranteeBatteryChargerForm.vue'
    ),
  WarrantyGuaranteeMotorForm: () =>
    import(
      /* webpackChunkName: "WarrantyGuaranteeMotorForm" */ '@/js/components/HubSpot/Forms/WarrantyGuaranteeMotorForm.vue'
    ),
  WarrantyGuaranteeSparepartDeliveryForm: () =>
    import(
      /* webpackChunkName: "WarrantyGuaranteeSparepartDeliveryForm" */ '@/js/components/HubSpot/Forms/WarrantyGuaranteeSparepartDeliveryForm.vue'
    ),
  WarrantyGuaranteeWarrantyClaimForm: () =>
    import(
      /* webpackChunkName: "WarrantyGuaranteeWarrantyClaimForm" */ '@/js/components/HubSpot/Forms/WarrantyGuaranteeWarrantyClaimForm.vue'
    ),
  WarrantyGuaranteePartNotFoundOtherComponentForm: () =>
    import(
      /* webpackChunkName: "WarrantyGuaranteePartNotFoundOtherComponentForm" */ '@/js/components/HubSpot/Forms/WarrantyGuaranteePartNotFoundOtherComponentForm.vue'
    ),
  WarrantyGuaranteeTransportPaintDamageForm: () =>
    import(
      /* webpackChunkName: "WarrantyGuaranteeTransportPaintDamageForm" */ '@/js/components/HubSpot/Forms/WarrantyGuaranteeTransportPaintDamageForm.vue'
    ),
  WarrantyGuaranteeTransportPackagingDamageForm: () =>
    import(
      /* webpackChunkName: "WarrantyGuaranteeTransportPackagingDamageForm" */ '@/js/components/HubSpot/Forms/WarrantyGuaranteeTransportPackagingDamageForm.vue'
    ),
  WarrantyGuaranteeAssemblyComponentDamageForm: () =>
    import(
      /* webpackChunkName: "WarrantyGuaranteeAssemblyComponentDamageForm" */ '@/js/components/HubSpot/Forms/WarrantyGuaranteeAssemblyComponentDamageForm.vue'
    ),
  WarrantyGuaranteeTransportWholeBikeDamageForm: () =>
    import(
      /* webpackChunkName: "WarrantyGuaranteeTransportWholeBikeDamageForm" */ '@/js/components/HubSpot/Forms/WarrantyGuaranteeTransportWholeBikeDamageForm.vue'
    ),
  WarrantyGuaranteeAssemblyPaintDamageForm: () =>
    import(
      /* webpackChunkName: "WarrantyGuaranteeAssemblyPaintDamageForm" */ '@/js/components/HubSpot/Forms/WarrantyGuaranteeAssemblyPaintDamageForm.vue'
    ),
  WarrantyGuaranteeTransportComponentDamageForm: () =>
    import(
      /* webpackChunkName: "WarrantyGuaranteeTransportComponentDamageForm" */ '@/js/components/HubSpot/Forms/WarrantyGuaranteeTransportComponentDamageForm.vue'
    ),
  WarrantyGuaranteeAssemblyComponentMountedIncorrectlyForm: () =>
    import(
      /* webpackChunkName: "WarrantyGuaranteeAssemblyComponentMountedIncorrectlyForm" */ '@/js/components/HubSpot/Forms/WarrantyGuaranteeAssemblyComponentMountedIncorrectlyForm.vue'
    ),
  WarrantyGuaranteeAssemblyWrongComponentForm: () =>
    import(
      /* webpackChunkName: "WarrantyGuaranteeAssemblyWrongComponentForm" */ '@/js/components/HubSpot/Forms/WarrantyGuaranteeAssemblyWrongComponentForm.vue'
    ),
  WarrantyGuaranteeReplacementPartMissingForm: () =>
    import(
      /* webpackChunkName: "WarrantyGuaranteeReplacementPartMissingForm" */ '@/js/components/HubSpot/Forms/WarrantyGuaranteeReplacementPartMissingForm.vue'
    ),
  WarrantyGuaranteeReplacementAskingDeliveryDateForm: () =>
    import(
      /* webpackChunkName: "WarrantyGuaranteeReplacementAskingDeliveryDateForm" */ '@/js/components/HubSpot/Forms/WarrantyGuaranteeReplacementAskingDeliveryDateForm.vue'
    ),
  WarrantyGuaranteeProductLiabilityForm: () =>
    import(
      /* webpackChunkName: "WarrantyGuaranteeProductLiabilityForm" */ '@/js/components/HubSpot/Forms/WarrantyGuaranteeProductLiabilityForm.vue'
    ),
  // BecomeTradingPartnerForm: () =>
  //   import(
  //     /* webpackChunkName: "BecomeTradingPartnerForm" */ '@/js/components/HubSpot/Forms/BecomeTradingPartnerForm.vue'
  //   ),
  OrderRequestBikeForm: () =>
    import(
      /* webpackChunkName: "OrderRequestBikeForm" */ '@/js/components/HubSpot/Forms/OrderRequestBikeForm.vue'
    ),
  OrderRequestSparePartAccessoriesForm: () =>
    import(
      /* webpackChunkName: "OrderRequestSparePartAccessoriesForm" */ '@/js/components/HubSpot/Forms/OrderRequestSparePartAccessoriesForm.vue'
    ),
  OrderShippingStatusBikeForm: () =>
    import(
      /* webpackChunkName: "OrderShippingStatusBikeForm" */ '@/js/components/HubSpot/Forms/OrderShippingStatusBikeForm.vue'
    ),
  OrderChangeCancellationRequestForm: () =>
    import(
      /* webpackChunkName: "OrderChangeCancellationRequestForm" */ '@/js/components/HubSpot/Forms/OrderChangeCancellationRequestForm.vue'
    ),
  OrderChangeExchangeItemForm: () =>
    import(
      /* webpackChunkName: "OrderChangeExchangeItemForm" */ '@/js/components/HubSpot/Forms/OrderChangeExchangeItemForm.vue'
    ),
  OrderChangeDeliveryDateForm: () =>
    import(
      /* webpackChunkName: "OrderChangeDeliveryDateForm" */ '@/js/components/HubSpot/Forms/OrderChangeDeliveryDateForm.vue'
    ),
  OrderChangePaymentTermForm: () =>
    import(
      /* webpackChunkName: "OrderChangePaymentTermForm" */ '@/js/components/HubSpot/Forms/OrderChangePaymentTermForm.vue'
    ),
  OrderBackorderForm: () =>
    import(
      /* webpackChunkName: "OrderBackorderForm" */ '@/js/components/HubSpot/Forms/OrderBackorderForm.vue'
    ),
  OrderOtherForm: () =>
    import(
      /* webpackChunkName: "OrderOtherForm" */ '@/js/components/HubSpot/Forms/OrderOtherForm.vue'
    ),
  ProductRequestOtherForm: () =>
    import(
      /* webpackChunkName: "ProductRequestOtherForm" */ '@/js/components/HubSpot/Forms/ProductRequestOtherForm.vue'
    ),
  PaymentTransactionsOtherForm: () =>
    import(
      /* webpackChunkName: "PaymentTransactionsOtherForm" */ '@/js/components/HubSpot/Forms/PaymentTransactionsOtherForm.vue'
    ),
  FeedbackOtherForm: () =>
    import(
      /* webpackChunkName: "FeedbackOtherForm" */ '@/js/components/HubSpot/Forms/FeedbackOtherForm.vue'
    ),
  WarrantyGuaranteeOtherForm: () =>
    import(
      /* webpackChunkName: "WarrantyGuaranteeOtherForm" */ '@/js/components/HubSpot/Forms/WarrantyGuaranteeOtherForm.vue'
    ),
  ProductRequestAvailabilityBikeForm: () =>
    import(
      /* webpackChunkName: "ProductRequestAvailabilityBikeForm" */ '@/js/components/HubSpot/Forms/ProductRequestAvailabilityBikeForm.vue'
    ),
  ProductRequestAvailabilitySparePartForm: () =>
    import(
      /* webpackChunkName: "ProductRequestAvailabilitySparePartForm" */ '@/js/components/HubSpot/Forms/ProductRequestAvailabilitySparePartForm.vue'
    ),
  PaymentTransactionsInvoiceCorrectionForm: () =>
    import(
      /* webpackChunkName: "PaymentTransactionsInvoiceCorrectionForm" */ '@/js/components/HubSpot/Forms/PaymentTransactionsInvoiceCorrectionForm.vue'
    ),
  PaymentTransactionsCreditsForm: () =>
    import(
      /* webpackChunkName: "PaymentTransactionsCreditsForm" */ '@/js/components/HubSpot/Forms/PaymentTransactionsCreditsForm.vue'
    ),
  PaymentTransactionsPaymentAgreementForm: () =>
    import(
      /* webpackChunkName: "PaymentTransactionsPaymentAgreementForm" */ '@/js/components/HubSpot/Forms/PaymentTransactionsPaymentAgreementForm.vue'
    ),
  PaymentTransactionsProofOfPaymentForm: () =>
    import(
      /* webpackChunkName: "PaymentTransactionsProofOfPaymentForm" */ '@/js/components/HubSpot/Forms/PaymentTransactionsProofOfPaymentForm.vue'
    ),
  MasterDataAddressesChangeNameForm: () =>
    import(
      /* webpackChunkName: "MasterDataAddressesChangeNameForm" */ '@/js/components/HubSpot/Forms/MasterDataAddressesChangeNameForm.vue'
    ),
  MasterDataAddressesChangeAddressForm: () =>
    import(
      /* webpackChunkName: "MasterDataAddressesChangeAddressForm" */ '@/js/components/HubSpot/Forms/MasterDataAddressesChangeAddressForm.vue'
    ),
  MasterDataAddressesChangeDeliveryAddressForm: () =>
    import(
      /* webpackChunkName: "MasterDataAddressesChangeDeliveryAddressForm" */ '@/js/components/HubSpot/Forms/MasterDataAddressesChangeDeliveryAddressForm.vue'
    ),
  WarrantyGuaranteePartNotFoundFrameForm: () =>
    import(
      /* webpackChunkName: "WarrantyGuaranteePartNotFoundFrameForm" */ '@/js/components/HubSpot/Forms/WarrantyGuaranteePartNotFoundFrameForm.vue'
    ),
  OtherForm: () =>
    import(/* webpackChunkName: "OtherForm" */ '@/js/components/HubSpot/Forms/OtherForm.vue'),
  EbikeSystemsImpulseForm: () =>
    import(
      /* webpackChunkName: "EbikeSystemsImpulseForm" */ '@/js/components/HubSpot/Forms/EbikeSystemsImpulseForm.vue'
    ),
  EbikeSystemsBoschForm: () =>
    import(
      /* webpackChunkName: "EbikeSystemsBoschForm" */ '@/js/components/HubSpot/Forms/EbikeSystemsBoschForm.vue'
    ),
  EbikeSystemsShimanoForm: () =>
    import(
      /* webpackChunkName: "EbikeSystemsShimanoForm" */ '@/js/components/HubSpot/Forms/EbikeSystemsShimanoForm.vue'
    ),
  EbikeSystemsFazuaForm: () =>
    import(
      /* webpackChunkName: "EbikeSystemsFazuaForm" */ '@/js/components/HubSpot/Forms/EbikeSystemsFazuaForm.vue'
    ),
  EbikeSystemsGrooveForm: () =>
    import(
      /* webpackChunkName: "EbikeSystemsGrooveForm" */ '@/js/components/HubSpot/Forms/EbikeSystemsGrooveForm.vue'
    ),
  EbikeSystemsContinentalForm: () =>
    import(
      /* webpackChunkName: "EbikeSystemsContinentalForm" */ '@/js/components/HubSpot/Forms/EbikeSystemsContinentalForm.vue'
    ),
  EbikeSystemsXionNeodriveForm: () =>
    import(
      /* webpackChunkName: "EbikeSystemsXionNeodriveForm" */ '@/js/components/HubSpot/Forms/EbikeSystemsXionNeodriveForm.vue'
    ),
  FeedbackDealerportalForm: () =>
    import(
      /* webpackChunkName: "FeedbackDealerportalForm" */ '@/js/components/HubSpot/Forms/FeedbackDealerportalForm.vue'
    ),
  FeedbackProcessForm: () =>
    import(
      /* webpackChunkName: "FeedbackProcessForm" */ '@/js/components/HubSpot/Forms/FeedbackProcessForm.vue'
    ),
  FeedbackSAPForm: () =>
    import(
      /* webpackChunkName: "FeedbackSAPForm" */ '@/js/components/HubSpot/Forms/FeedbackSAPForm.vue'
    ),
  FeedbackServiceForm: () =>
    import(
      /* webpackChunkName: "FeedbackServiceForm" */ '@/js/components/HubSpot/Forms/FeedbackServiceForm.vue'
    ),
  FeedbackProductForm: () =>
    import(
      /* webpackChunkName: "FeedbackProductForm" */ '@/js/components/HubSpot/Forms/FeedbackProductForm.vue'
    ),
  FeedbackDeliveryForm: () =>
    import(
      /* webpackChunkName: "FeedbackDeliveryForm" */ '@/js/components/HubSpot/Forms/FeedbackDeliveryForm.vue'
    ),
  FeedbackTelephoneForm: () =>
    import(
      /* webpackChunkName: "FeedbackTelephoneForm" */ '@/js/components/HubSpot/Forms/FeedbackTelephoneForm.vue'
    ),
}
